// For full API documentation, including code examples, visit https://wix.to/94BuAAs

import wixWindow from 'wix-window';

$w.onReady(function () {
	if (wixWindow.multilingual.currentLanguage === 'en') {
		$w('#horizontalMenu2').show();
		$w('#horizontalMenu1').hide();
	}
});